import { CheckIcon } from "@chakra-ui/icons";
import { Box, Button, ButtonGroup, FormLabel } from "@chakra-ui/react";
import React from "react";

export type ReviewFilterValue = "all" | "reviewed";

interface ReviewFilterProps {
  initialValue?: ReviewFilterValue;
  value?: ReviewFilterValue;
  onChange: (value: ReviewFilterValue) => void;
}

export default function ReviewFilter({
  initialValue = "all",
  value,
  onChange,
}: ReviewFilterProps) {

  const [internalValue, setInternalValue] =
    React.useState<ReviewFilterValue>(initialValue);
  const selectedValue = value ?? internalValue;

  const onHandleChange = React.useCallback((nextValue: ReviewFilterValue) => {
    if (value === undefined) {
      setInternalValue(nextValue);
    }
    onChange(nextValue);
  }, [onChange, value])

  return (
    <Box>
      <FormLabel fontSize="sm" color="gray.600">
        Status de Revisão
      </FormLabel>
      <ButtonGroup size="sm" isAttached variant="outline">
        <Button
          onClick={() => onHandleChange("all")}
          variant={selectedValue === "all" ? "solid" : "outline"}
          colorScheme="gray"
          leftIcon={selectedValue === "all" ? <CheckIcon boxSize="3" /> : undefined}
        >
          Todos
        </Button>

        <Button
          onClick={() => onHandleChange("reviewed")}
          variant={selectedValue === "reviewed" ? "solid" : "outline"}
          colorScheme="gray"
          leftIcon={
            selectedValue === "reviewed" ? <CheckIcon boxSize="3" /> : undefined
          }
        >
          Revisados
        </Button>
      </ButtonGroup>
    </Box>
  );
}
